import api from "../api/client";

const freightApi2 = {
  create(payload) {
    return api.post("/freight/save", payload);
  },

  update(id, payload, isFinalize = false) {
    return api.patch(
      `/freight/update/${id}?isFinalize=${isFinalize}`,
      payload
    );
  },

  getById(id) {
    return api.get(`/freight/getFreightByIdWithStoppingPoints/${id}`);
  },

  getAllFreights(params) {
    return api.get("/freight", { params });
  },

  /*Lista paginada (cursor) com filtros no servidor — GET /freight/v2 */
  getAllFreightsV2(params) {
    return api.get("/freight/v2", { params });
  },

  delete(id) {
    return api.delete(`/freight/delete/${id}`);
  },

  queue(id) {
    return api.get(`/freight/${id}/queue`);
  },
};

export default freightApi2;